import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { State, Action, Getter, Mutation } from 'vuex-class';

import TkField from '@/../bower_components/teknisavuecomponents/components/fields/TkField.vue';
import TkFile from '@/../bower_components/teknisavuecomponents/components/document/TkFile/TkFile.vue';
import TkToolbar from '@/../bower_components/teknisavuecomponents/components/grids/TkToolbar.vue';

import CommonRequests from '@/assets/ts/controller/CommonRequests';
import IndicadoresController from '@/assets/ts/controller/IndicadoresController';
import NovaSolicitacaoController from '@/assets/ts/controller/NovaSolicitacaoController';

import User from '@/../bower_components/teknisavuecomponents/assets/interfaces/User';
import SnackbarUtils from '@/../bower_components/teknisavuecomponents/assets/utils/SnackbarUtils';
import Estrutura from '@/../bower_components/teknisavuecomponents/assets/interfaces/Estrutura';
import Field from '@/../bower_components/teknisavuecomponents/assets/interfaces/Field';
import Periodo from '@/../bower_components/teknisavuecomponents/assets/interfaces/Periodo';
import VueApexCharts from 'vue-apexcharts';
import DateUtil from '@/../bower_components/teknisavuecomponents/assets/utils/DateUtil';
import ToolbarAction from '@/../bower_components/teknisavuecomponents/assets/interfaces/ToolbarAction';

@Component({
  name: 'IndicadoresReunioes',
  components: {
    TkFile,
    TkField,
    TkToolbar,
    apexchart: VueApexCharts,
  },
})
class IndicadoresReunioes extends Vue {
  // #region [ STORE ]

  private get user(): User {
    return this.$store.getters.user;
  }

  private get estruturaGerencialAtual(): Estrutura {
    return this.$store.getters.estruturaGerencialAtual;
  }

  private get periodoDemonstrativoAtual(): Periodo {
    return this.$store.getters.periodoDemonstrativoAtual;
  }

  @Mutation('changeCurrentView')
  private changeCurrentView: (string) => void;

  @Mutation('updateEstruturaGerencialAtual')
  private updateEstruturaGerencialAtual: (any) => void;

  private get estruturasGerenciaisStore(): Estrutura[] {
    return this.$store.getters.estruturasGerenciais;
  }

  private chart?: ApexCharts;

  private async getReuniaoPorMes() {
    try {
      const dtmesCompetenc = DateUtil.getDateCompetenc();
      const dp             = this.user.dp
      const dataset        = await IndicadoresController.getReuniaoPorMes(dtmesCompetenc,dp);
      
      const totais: number[] = [];
      const datas: string[] = [];
      
      for (const data of dataset) {
        totais.push(parseInt(data.TOTAL, 10));
        datas.push(data.DTDATA);
      }

      this.seriesReuniaoPorMes = [{ data: totais }];
      this.chartOptionsReuniaoPorMes.xaxis.categories = datas;
   
      this.$nextTick(() => {
        if (this.$refs.chart && (this.$refs.ReuniaoPorMes as any).chart) {
          this.chart = (this.$refs.ReuniaoPorMes as any).chart;

          this.chart.updateSeries(totais);
          this.chart.updateOptions({
            xaxis: {
              categories: datas
            }
          }); 
        }
      });  
    } catch (err) {
      const message = 'Não foi possível carregar o total de reuniões por mês!';
      SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ERROR);

      throw err;
    }
  }

  private async getReuniaoPorAno() {
    try {
      const dtmesCompetenc = DateUtil.getDateCompetenc();
      const dp             = this.user.dp
      const dataset        = await IndicadoresController.getReuniaoPorAno(dtmesCompetenc, dp);
      
      const totais: number[] = [];
      const datas: string[] = [];
      
      for (const data of dataset) {
        totais.push(parseInt(data.TOTAL, 10));
        datas.push(data.DTDATA);
      }

      this.seriesReuniaoPorAno = [{ data: totais }];
      this.chartOptionsReuniaoPorAno.xaxis.categories = datas;

      this.$nextTick(() => {
        if (this.$refs.chart && (this.$refs.ReuniaoPorAno as any).chart) {
          this.chart = (this.$refs.ReuniaoPorAno as any).chart;

          this.chart.updateSeries(totais);
          this.chart.updateOptions({
            xaxis: {
              categories: datas
            }
          });
        }
      }); 
    } catch (err) {
      const message = 'Não foi possível carregar o total de reuniões por ano!';
      SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ERROR);

      throw err;
    }
  }

  private async getTotalReuniaoPorTipoReuniao() {
    try {
      const dtmesCompetenc = DateUtil.getDateCompetenc();
      const dp             = this.user.dp
      const dataset = await IndicadoresController.getTotalReuniaoPorTipoReuniao(dtmesCompetenc, dp);
  
      const qntdReunioes: number[] = [];
      const indicadores: string[] = [];
      
      for (const total of dataset) {
        qntdReunioes.push(parseInt(total.QTD_REUNIOES, 10));
        indicadores.push(total.INDICADOR);
      }
      
      this.seriesTotalReunioesPorTipoReuniao = qntdReunioes     
      this.chartOptionsTotalReunioesPorTipoReuniao.labels = indicadores;

      this.$nextTick(() => {
        if (this.$refs.chart && (this.$refs.TotalReuniaoPorTipoReuniao as any).chart) {
          this.chart = (this.$refs.TotalReuniaoPorTipoReuniao as any).chart;

          this.chart.updateSeries(qntdReunioes);
          this.chart.updateOptions({ labels: indicadores });
        }
       
      }); 

    } catch (err) {
      const message = 'Não foi possível carregar o total de reunião por tipo de reunião!';
      SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ERROR);

      throw err;
    }
  }

  // #endregion

  // #region [ DATA ]
  private readonly viewTitle = 'Indicadores de Reuniões';

  
  // Graficos
  private seriesReuniaoPorMes = [{ data: [] as number[] }];

  private chartOptionsReuniaoPorMes = {
    chart: {
      type: 'bar',
      height: 380,
      toolbar: {
        show: true,
        tools: {
          download: true
        },
        export: {
          csv: {
            filename: 'reunioes_por_mes',
          },
          svg: {
            filename: 'reunioes_por_mes',
          },
          png: {
            filename: 'reunioes_por_mes',
          }
        }
      }
  },
  title: {
    text: 'Total de Reuniões por Mês',
  },
  plotOptions: {
      bar: {
          borderRadius: 10,
          dataLabels: {
              position: 'top',
              enabled: true,
              style: {
                  colors: ['#'] 
              },
              formatter: function (val, opt) {
                  return val;
              },
              offsetX: 20,
              dropShadow: {
                  enabled: true
              }
          },
      }
  },
  dataLabels: {
      enabled: true,
      style: {
        fontSize: '14px', 
        fontWeight: 'bold',
        colors: ['#000'] 
      },
      formatter: function (val, opt) {
          return val;
      },
      offsetX: 20,
      dropShadow: {
          enabled: true
      }
  },
  stroke: {
      width: 1,
      colors: ['#fff']
  },
  xaxis: {
      categories: [],
      position: 'top',
      axisBorder: {
        show: false
      },
      axisTicks: {
        show: false
      },
      crosshairs: {
        fill: {
          type: 'gradient',
          gradient: {
            colorFrom: '#D8E3F0',
            colorTo: '#BED1E6',
            stops: [0, 100],
            opacityFrom: 0.4,
            opacityTo: 0.5,
          }
        }
      },
      tooltip: {
        enabled: true,
      }
  },
  yaxis: {
    axisBorder: {
      show: false
    },
    axisTicks: {
      show: false,
    },
    labels: {
      show: false,
      formatter: function (val) {
        return val + "%";
      }
    }
  
  },
  legend: {
    position: 'top'
  },
  tooltip: {
      theme: 'dark',
      y: {
          title: {
              formatter: function () {
                  return '';
              }
          }
      }
  }
};

  private seriesReuniaoPorAno = [{ data: [] as number[] }];

  private chartOptionsReuniaoPorAno = {
    chart: {
      type: 'bar',
      height: 380,
      toolbar: {
        show: true,
        tools: {
          download: true
        },
        export: {
          csv: {
            filename: 'reunioes_por_ano',
          },
          svg: {
            filename: 'reunioes_por_ano',
          },
          png: {
            filename: 'reunioes_por_ano',
          }
        }
      }
  },
  title: {
    text: 'Total de Reuniões por Ano',
  },
  plotOptions: {
      bar: {
          borderRadius: 10,
          dataLabels: {
              position: 'top',
              enabled: true,
              style: {
                  colors: ['#'] 
              },
              formatter: function (val, opt) {
                  return val;
              },
              offsetX: 20,
              dropShadow: {
                  enabled: true
              }
          },
      }
  },
  dataLabels: {
      enabled: true,
      style: {
        fontSize: '14px', 
        fontWeight: 'bold',
        colors: ['#000'] 
      },
      formatter: function (val, opt) {
          return val;
      },
      offsetX: 20,
      dropShadow: {
          enabled: true
      }
  },
  stroke: {
      width: 1,
      colors: ['#fff']
  },
  xaxis: {
      categories: [],
      position: 'top',
      axisBorder: {
        show: false
      },
      axisTicks: {
        show: false
      },
      crosshairs: {
        fill: {
          type: 'gradient',
          gradient: {
            colorFrom: '#D8E3F0',
            colorTo: '#BED1E6',
            stops: [0, 100],
            opacityFrom: 0.4,
            opacityTo: 0.5,
          }
        }
      },
      tooltip: {
        enabled: true,
      }
  },
  yaxis: {
    axisBorder: {
      show: false
    },
    axisTicks: {
      show: false,
    },
    labels: {
      show: false,
      formatter: function (val) {
        return val + "%";
      }
    }
  
  },
  legend: {
    position: 'top'
  },
  tooltip: {
      theme: 'dark',
      y: {
          title: {
              formatter: function () {
                  return '';
              }
          }
      }
  }
};
private seriesTotalReunioesPorTipoReuniao: number[] = [];
private chartOptionsTotalReunioesPorTipoReuniao = {
  chart: {
    type: 'donut',
    toolbar: {
      show: true,
      tools: {
        download: true
      },
      export: {
        csv: {
          filename: 'total_reunioes_por_tipo_reuniao',
        },
        svg: {
          filename: 'total_reunioes_por_tipo_reuniao',
        },
        png: {
          filename: 'total_reunioes_por_tipo_reuniao',
        }
      }
    }
  },
  title: {
    text: 'Total de Reuniões por Tipo Reunião',
  },
  labels: [] as string[],
  stroke: {
    colors: ['#fff'],
  },
  fill: {
    opacity: 0.8,
  },
  responsive: [
    {
      breakpoint: 480,
      options: {
        chart: {
          width: 200,
        },
        legend: {
          position: 'bottom',
        },
      },
    },
  ],
};

  private loading = false;

  private estruturasGerenciais: any[] = [];
  private estruturasLegais: any[] = [];
  private nrEstrutLegal = '';
  private nrEstrutGeren = '';
  // #endregion

  // #region [ COMPUTED ]
  private get estruturaGerencialField(): Field {
    const descField = 'NMESTRUTURA';
    const field = {
      name: 'NRESTRUTGEREN',
      valueField: 'NRESTRUTURAM',
      descriptionField: descField,
      label: 'Estrutura Gerencial',
      type: 'autocomplete',
      size: 6,
      items: this.estruturasGerenciais,
    };

    return field;
  }

  private get estruturaLegalField(): Field {
    const field: Field = {
      name: 'NRESTRUTLEGAL',
      valueField: 'NRESTRUTURAM',
      descriptionField: 'NRNMESTRUTURA',
      label: 'Estrutura Legal',
      type: 'autocomplete',
      size: 6,
      items: this.estruturasLegais,
    };

    return field;
  }

  private get toolbarActions(): ToolbarAction[] {
    const actions = [
      {
        name: 'reload',
        label: 'Atualizar',
        icon: 'mdi-refresh',
        onClick: this.reload,
        disabled: this.loading,
      },
    ];

    return actions;
  }

  // #endregion

  // #region [ LIFECYCLE ]
  private created() {
    this.changeCurrentView(this.viewTitle);
    this.getReuniaoPorMes();
    this.getReuniaoPorAno();
    this.getTotalReuniaoPorTipoReuniao();
  }

  private mounted() {
    this.loadEstruturasGerenciais();
    this.loadEstruturasLegais();
  }
  // #endregion

  // #region [ WATCHERS ]
  @Watch('estruturaGerencialAtual')
  private estruturaGerencialAtualOnChange() {
    this.reload();
  }

  @Watch('periodoDemonstrativoAtual')
  private periodoDemonstrativoAtualOnChange() {
    this.reload();
  }
  // #endregion

  // #region [ METHODS ]
  private async reload() {
    if (!this.periodoDemonstrativoAtual || !this.estruturaGerencialAtual) {
      return;
    }

    this.loading = true;

    try {
      await Promise.all([
          this.getReuniaoPorMes(),
          this.getReuniaoPorAno(),
          this.getTotalReuniaoPorTipoReuniao(),
      ]);
    } finally {
      this.loading = false;
    }
  }

  private async loadEstruturasGerenciais() {
    let estruturas = [];

    if (this.user.dp) {
      try {
        estruturas = await NovaSolicitacaoController.getEstruturas('GERENCIAL');
      } catch {
        const message = 'Não foi possível carregar as estruturas gerenciais!';
        SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ERROR);
      }
    } else {
      estruturas = this.estruturasGerenciaisStore.filter((estrutura) => {
        const isGerencial = estrutura.IDTIPOESTRUTURA === 'GERENCIAL';
        return isGerencial;
      });
    }

    this.estruturasGerenciais = estruturas;
  }

  private async loadEstruturasLegais() {
    try {
      const estruturas = await NovaSolicitacaoController.getEstruturas('LEGAL');
      this.estruturasLegais = estruturas;
    } catch (err) {
      const message = 'Não foi possível carregar as estruturas legais!';
      SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ERROR);

      throw err;
    }
  }
  // #endregion
}

export default IndicadoresReunioes;